import AvatarGroup from "@mui/material/AvatarGroup";
import type {Theme} from "@mui/material/styles";
import {memo} from "react";
import type {ReactNode} from "react";

const rootSx = (theme: Theme) => ({
    display: "inline-flex",
    verticalAlign: "-5px",
    marginRight: "-2px",

    "& .MuiAvatarGroup-avatar": {
        border: `2px solid ${theme.palette.background.paper}`,
        marginLeft: "-6px",
    },

    "& a:first-child .MuiAvatarGroup-avatar": {
        marginLeft: "0px",
    },

    "& div": {
        width: "24px",
        height: "24px",
        fontSize: "12px",
        marginLeft: "-6px",
        border: `2px solid ${theme.palette.background.paper}`,
    },

    "& a:first-child div": {
        marginLeft: "0px",
    },
});

export interface ContributorAvatarsProps {
    contributorUids: string[];
    /** Renders a single contributor's avatar; injected by the host app. */
    renderAvatar: (uid: string) => ReactNode;
    /** Maximum avatars shown before collapsing into a +N overflow. */
    max?: number;
}

/**
 * Bounded contributor avatar strip: overlapping avatars capped at `max`, with
 * MUI's AvatarGroup +N overflow for the rest.
 */
export const ContributorAvatars = memo(function ContributorAvatars(props: ContributorAvatarsProps) {
    const {contributorUids, renderAvatar, max = 4} = props;
    const uids = contributorUids.filter((uid) => uid);

    if (uids.length === 0) {
        return null;
    }

    return (
        <AvatarGroup max={max} sx={rootSx}>
            {uids.map((uid) => renderAvatar(uid))}
        </AvatarGroup>
    );
});
